import { sleep } from "@/lib/darknessApi";

const PROBE_MS = 4000;

// Only wipe when the server is reachable, otherwise the device would be left with no app.
export const serverReachable = async () => {
  if (!navigator.onLine) return false;
  try {
    const r = await Promise.race([fetch(`/version.json?hr=${Date.now()}`, { cache: "no-store" }), sleep(PROBE_MS)]);
    return Boolean(r && r.ok);
  } catch (e) {
    return false;
  }
};

export const wipeAndReload = async () => {
  try { localStorage.clear(); sessionStorage.clear(); } catch (e) { /* storage blocked */ }
  try {
    if ("caches" in window) await Promise.all((await caches.keys()).map((k) => caches.delete(k)));
  } catch (e) { /* no cache storage */ }
  try {
    if ("serviceWorker" in navigator) await Promise.all((await navigator.serviceWorker.getRegistrations()).map((r) => r.unregister()));
  } catch (e) { /* no service worker */ }
  window.location.replace(`/?hr=${Date.now()}`);
};
